<div class="float-end arrows-icon px-2">
  <mat-icon style="height: 45px;" [inline]="true" (click)="goToCreateCentro()" *ngIf="this.cebe?.edicionCebe">
    add
  </mat-icon>
</div>
<table>
  <thead>
    <tr>
      <th>{{ 'centro.centroData.code' | translate}}</th>
      <th>{{ 'centro.centroData.description' | translate}}</th>
      <th>{{"centro.centroData.installationType" | translate}}</th>
      <th>{{ "centro.centroData.plantManager" | translate }}</th>
      <th>{{ 'centro.centroData.country' | translate}}</th>
      <th>{{ 'centro.centroData.province' | translate}}</th>
      <th class="center">{{ 'centro.centroData.active' | translate}}</th>
      <th class="center" *ngIf="isAdmin">{{ 'centro.centroData.export' | translate}}</th>
    </tr>
  </thead>
  <tbody *ngIf="centros.length>0">
    <tr *ngFor="let centro of centros" (click)="redirigirDetalle(centro)">
      <td>{{ centro.codigo }}</td>
      <td>{{ centro.descripcion }}</td>
      <td>{{ "centro.installations." + centro.codigoTipoInstalacion | translate }}</td>
      <td>{{ centro.responsable_Planta }}</td>
      <td>{{ "countries." + centro.codigoPais | translate }}</td>
      <td>{{ centro.ciudad }}</td>
      <td class="center">
        <span *ngIf="centro.activo; else inactivo">&#10004;</span>
        <ng-template #inactivo>&#10006;</ng-template>
      </td>
      <td class="center" *ngIf="isAdmin">
        <a (click)="exportToExcel($event,centro.id)">
          <i class="fas fa-file-excel"></i>
        </a>
      </td>

    </tr>
  </tbody>
</table>